import Vue from 'vue'

const ENTITYCATEGORY_SET_NAME =(state, payload)=> {
            
    state.data.name = payload
};


const ENTITYCATEGORY_SET_DUPLICATE =(state, payload)=> {
            
    state.data.duplicate = payload
};


const ENTITYCATEGORY_SET_ENTITYCATEGORIES =(state, payload)=> {  
    
    state.entitycategories=payload
    
};

const ENTITYCATEGORY_SET_ENTITYCATEGORY =(state, payload)=> {       
    
    state.data.name = payload.name
       
};

const ENTITYCATEGORY_INIT_ENTITYCATEGORY =(state, payload)=> {       
    state.data.name = ''        
};



export default {
    ENTITYCATEGORY_SET_NAME,    
    ENTITYCATEGORY_SET_DUPLICATE,
    ENTITYCATEGORY_SET_ENTITYCATEGORIES,
    ENTITYCATEGORY_SET_ENTITYCATEGORY,
    ENTITYCATEGORY_INIT_ENTITYCATEGORY,
};